/**
 * 工具专用配置模块
 */

import { getPromptExample } from "../../service/commonApi";

const state = {
  caseConfig: {},
};

const mutations = {
  // 设置示例
  setCaseConfig(state, data) {
    state.caseConfig = data;
  },
};

const actions = {
  // 获取示例
  async getCaseConfig({ commit }) {
    const res = await getPromptExample();
    commit("setCaseConfig", res.data);
  },
};

const getters = {
  // 获取示例
  getCase: (state) => (key) => {
    return state.caseConfig[key];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
